import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-influencia-empresa',
  standalone: true,
  imports: [
    NgForOf,
    NgOptimizedImage
  ],
  templateUrl: './influencia-empresa.component.html',
  styleUrl: './influencia-empresa.component.css'
})
export class InfluenciaEmpresaComponent {




}
